import api from './api';

export interface DepartamentoResult {
    id: string;
    nome: string;
    descricao?: string;
    usuarioResponsavelId?: string;
    areaId: string;
    valid: boolean;
    sigla: string;
    diretoriaId: string;
    usuarioSubstitutoId?: string;
    dataFinal?: Date;
    dataInicial?: Date;
}
export interface Validacao {
    valid: boolean;
}


export interface DepartamentoPesquisaResult {
    id: string;
    nome: string;
    descricao: string;
    usuarioResponsavelId?: string;
    areaId: string;
    diretoriaId: string;
    valid: boolean;
    sigla: string;
    areaNome: string;
    nomeUsuario: string;
    userName: string;
}


export const getAllDepartamento = () => api.get<DepartamentoPesquisaResult[]>('departamentos');
export const getAllDepartamentoProAreaId = (areaId: string) => api.get<DepartamentoPesquisaResult[]>(`departamentos/getAllDepartamentoProAreaId/${areaId}`);
export const getAllDepartamentoProDiretoriaId = (diretoriaId: string) => api.get<DepartamentoPesquisaResult[]>(`departamentos/getAllDepartamentoProDiretoriaId/${diretoriaId}`);

export const createDepartamento = (departamento: DepartamentoResult) => {
    return api.post<any>('departamentos', departamento);
};
export const updateDepartamento = (departamento: DepartamentoResult) => api.put<any>(`departamentos/${departamento.id}`, departamento);
export const deleteDepartamento = (id: string) => api.delete<Validacao>(`departamentos/${id}`);

export const getAllDepartamentoOptions = () =>
    getAllDepartamento().then(areas => (areas || []).map(a => ({ text: a.nome, value: a.id.toString() })));


export const getAllDepartamentoProAreaIdOptions = (areaId: string) =>
    getAllDepartamentoProAreaId(areaId).then(areas => (areas || []).map(a => ({ text: a.nome, value: a.id.toString() })));

export const getAllDepartamentoProDiretoriaIdOptions = (diretoriaId: any) =>
    getAllDepartamentoProDiretoriaId(diretoriaId).then(areas => (areas || []).map(a => ({ text: a.nome, value: a.id.toString() })));
